import { createContext, type RefObject } from "react";

type SectionsContextType = {
    active: unknown | null;
    setActive: (sectionId: unknown | null) => void;
};

export const SectionsContext = createContext<SectionsContextType | null>(null);

type SectionContextType = {
    sectionId: unknown;
    ref: RefObject<HTMLDivElement | null>;
    closeSection: () => void;
};

export const SectionContext = createContext<SectionContextType | null>(null);
